function t(t){return"[object Object]"===Object.prototype.toString.call(t)}function e(t,e){return Object.prototype.hasOwnProperty.call(e,t)}export{e as _,t as a};
